import React from 'react'

export default props => <svg
  width="17"
  height="21"
  viewBox="0 0 17 21"
  fill="none"
  {...props}
>
  <path d="M0 14C0 15.2834 1.04434 16.3334 2.32078 16.3334H11.6039C12.8803 16.3334 13.9246 15.2834 13.9246 14V1.00136e-08H0V14Z" transform="translate(1.16016 4.66602)" fill="url(#BinIconSvg_paint0_linear)"/>
  <path d="M12.184 1.16665L11.0236 0H5.22172L4.0613 1.16665H-9.95965e-09V3.50001H16.2453V1.16665H12.184Z" fill="url(#BinIconSvg_paint1_linear)"/>
  <path d="M5.43594e-05 1.65086L1.64201 0L4.10199 2.47336L6.56202 0L8.20398 1.65086L5.74395 4.12421L8.20398 6.59757L6.56202 8.24843L4.10199 5.77502L1.64196 8.24837L0 6.59752L2.46003 4.12416L5.43594e-05 1.65086Z" transform="translate(4 8.70898)" fill="url(#BinIconSvg_paint2_linear)"/>
  <defs>
    <linearGradient id="BinIconSvg_paint0_linear" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.9246 16.3334) scale(13.9246 16.3334) rotate(180)">
    <stop stopColor="#FC4A1A"/>
    <stop offset="1" stopColor="#F7B733"/>
    </linearGradient>
    <linearGradient id="BinIconSvg_paint1_linear" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.2453 3.50001) scale(16.2453 3.50001) rotate(180)">
    <stop stopColor="#FC4A1A"/>
    <stop offset="1" stopColor="#F7B733"/>
    </linearGradient>
    <linearGradient id="BinIconSvg_paint2_linear" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11.0652 12.2904) scale(13.9246 16.3334) rotate(180)">
      <stop stopColor="white"/>
      <stop offset="1" stopColor="white"/>
    </linearGradient>
  </defs>
</svg>



// WEBPACK FOOTER //
// ./src/modules/ListControl/BinIconSvg.js